import { useDashTour } from 'sections/Dashboard/hooks'
import { useTranslation } from 'react-i18next'
import { DashboardHelpContainer } from './style'

function DashboardHelp() {
  const { t } = useTranslation()
  const launchTour = useDashTour()

  return (
    <DashboardHelpContainer>
      <h4 className="mr-3 cursor" onClick={launchTour}>
        {t('dashboard_tour_btn')}
      </h4>
    </DashboardHelpContainer>
  )
}

export default DashboardHelp
